import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faStar } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const JobCard = ({ job, showJobDetails }) => {
  const [hovered, setHovered] = useState(false);
  const score = job._score ? Math.round(job._score * 10) / 10 : null;

  return (
    <div
      onClick={() => showJobDetails(job)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "12px 14px",
        borderRadius: "10px",
        background: hovered ? "#f0f4ff" : "#f8f9fb",
        marginBottom: "8px",
        cursor: "pointer",
        transition: "background 0.15s",
        borderLeft: `3px solid ${hovered ? "#1a73e8" : "transparent"}`,
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
        <div style={{
          width: "30px", height: "30px", borderRadius: "8px", flexShrink: 0,
          background: "#e8f0fe", display: "flex", alignItems: "center",
          justifyContent: "center", color: "#1a73e8", fontSize: "0.75rem",
        }}>
          <FontAwesomeIcon icon={faBriefcase} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: "0.88rem", color: "#212121", marginBottom: "3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {job._source.jobtitle}
          </div>
          {job._source.description && (
            <div style={{ fontSize: "0.77rem", color: "#757575", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {job._source.description}
            </div>
          )}
        </div>
        {score !== null && (
          <div style={{
            display: "flex", alignItems: "center", gap: "3px",
            fontSize: "0.72rem", fontWeight: 700, color: "#f57c00",
            flexShrink: 0,
          }}>
            <FontAwesomeIcon icon={faStar} style={{ fontSize: "0.65rem" }} />
            {score}
          </div>
        )}
      </div>
    </div>
  );
};

export default JobCard;
